// 桌面端适配
import "vant/lib/index.css";
import "@vant/touch-emulator";
// 引入 Vant 基础样式
import "./index.less";

// 引入自定义样式

export default defineNuxtPlugin(() => {});
